"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAttractionsContent = formatAttractionsContent;
exports.formatCheckInDescription = formatCheckInDescription;
exports.formatDescriptionsContentSection = formatDescriptionsContentSection;
exports.formatMaldivesTransfer = formatMaldivesTransfer;
exports.formatPolicyContentSection = formatPolicyContentSection;
exports.formatSpokenLanguages = formatSpokenLanguages;
exports.getAccessibilityFacility = getAccessibilityFacility;
exports.getAdultLowestPrice = getAdultLowestPrice;
exports.getSmokingFacility = getSmokingFacility;
exports.isArabicLanguagePresent = isArabicLanguagePresent;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _includes2 = _interopRequireDefault(require("lodash/includes"));
var _toLower2 = _interopRequireDefault(require("lodash/toLower"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _split2 = _interopRequireDefault(require("lodash/split"));
var _dateFns = require("date-fns");
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _constants = require("../constants");
var _language = require("./language.utils");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * format policies content section  [hotelInfo api =>  policies]
 * @param {Array<object>} policies
 * @param {number} id
 * @param {string} language
 * @return {{title: string, html: string, id: number}}
 */
function formatPolicyContentSection(_ref) {
  var policies = _ref.policies,
    id = _ref.id,
    language = _ref.language;
  var section = (0, _find2["default"])(policies, {
    hotelPolicyCategoryId: id
  });
  var title = (0, _language.translate2keysLabel)((0, _get2["default"])(section, 'category'), 'title', language);
  var html = (0, _language.translate2keysLabel)(section, 'policyDetails', language);
  return {
    title: title,
    html: html,
    id: id
  };
}

/**
 * format descriptions content section [hotelInfo api =>  descriptions]
 * @param {Array<object>} descriptions
 * @param {string} id
 * @param {string} language
 * @return {{title: string, html: string, id: number}}
 */
function formatDescriptionsContentSection(_ref2) {
  var descriptions = _ref2.descriptions,
    enTitle = _ref2.enTitle,
    language = _ref2.language;
  var section = (0, _find2["default"])(descriptions, function (cat) {
    return (0, _get2["default"])(cat, 'hotelDescriptionCategory.descriptionEn') === enTitle;
  });
  var title = (0, _language.translate2keysLabel)((0, _get2["default"])(section, 'hotelDescriptionCategory'), 'description', language);
  var html = (0, _language.translate2keysLabel)(section, 'description', language);
  return {
    id: enTitle,
    title: title,
    html: html
  };
}

/**
 * format descriptions content for spoken Language
 * @param {Array<object>} descriptions
 * @param {string} id
 * @param {string} language
 * @return {{title: string, html: string, id: number}}
 */
function formatSpokenLanguages(_ref3) {
  var descriptions = _ref3.descriptions,
    enTitle = _ref3.enTitle,
    language = _ref3.language;
  var section = (0, _find2["default"])(descriptions, function (cat) {
    return (0, _get2["default"])(cat, 'hotelDescriptionCategory.descriptionEn') === enTitle;
  });
  var title = (0, _language.translate2keysLabel)((0, _get2["default"])(section, 'hotelDescriptionCategory'), 'description', language);
  var list = (0, _split2["default"])((0, _get2["default"])(section, 'descriptionEn', ''), ',');
  return {
    id: enTitle,
    title: title,
    list: list
  };
}

/**
 * format MalviesData
 * @param {object} data
 * @param {object} currency store
 * @param {Function} formatPrice  currency method
 * @return {{object}}
 */
function formatMaldivesTransfer(_ref4) {
  var _currency$currenciesL;
  var data = _ref4.data,
    currency = _ref4.currency,
    formatPrice = _ref4.formatPrice;
  var currencyRate = currency === null || currency === void 0 ? void 0 : (_currency$currenciesL = currency.currenciesList.filter(function (currency) {
    var _data$en$;
    return (currency === null || currency === void 0 ? void 0 : currency.code) == (data === null || data === void 0 ? void 0 : (_data$en$ = data.en[0]) === null || _data$en$ === void 0 ? void 0 : _data$en$.currency);
  })[0]) === null || _currency$currenciesL === void 0 ? void 0 : _currency$currenciesL.rate;
  var formattedMaldivesTransfer = {};
  currencyRate && Object.entries(data).forEach(function (_ref5) {
    var _ref6 = (0, _slicedToArray2["default"])(_ref5, 2),
      key = _ref6[0],
      object = _ref6[1];
    var formattedCurrency = object.map(function (value) {
      var currencyConvertedPrice = _objectSpread({}, value);
      currencyConvertedPrice.adultPrice = value !== null && value !== void 0 && value.adultPrice ? formatPrice((value.adultPrice.replace(',', '') / currencyRate).toFixed(0)) : value === null || value === void 0 ? void 0 : value.adultPrice;
      currencyConvertedPrice.childPrice = value !== null && value !== void 0 && value.childPrice ? formatPrice((value.childPrice.replace(',', '') / currencyRate).toFixed(0)) : value === null || value === void 0 ? void 0 : value.childPrice;
      currencyConvertedPrice.infantPrice = value !== null && value !== void 0 && value.infantPrice ? formatPrice((value.infantPrice.replace(',', '') / currencyRate).toFixed(0)) : value === null || value === void 0 ? void 0 : value.infantPrice;
      return currencyConvertedPrice;
    });
    formattedMaldivesTransfer[key] = (0, _toConsumableArray2["default"])(formattedCurrency);
  });
  return formattedMaldivesTransfer;
}

/**
 * sort maldives transfer and send the lowest price
 * @param {object} data
 * @return {string}
 */
function getAdultLowestPrice(_ref7) {
  var _data$en$sort$;
  var data = _ref7.data;
  return data === null || data === void 0 ? void 0 : (_data$en$sort$ = data.en.sort(function (a, b) {
    return a.adultPrice - b.adultPrice;
  })[0]) === null || _data$en$sort$ === void 0 ? void 0 : _data$en$sort$.adultPrice;
}

/**
 * format attractions content
 * @param {string} attractionsDescription
 * @param {string} nearestAirportsTitle
 * @return {{pointsOfInterest: Array, nearestAirports: Array}}
 */
function formatAttractionsContent(_ref8) {
  var attractionsDescription = _ref8.attractionsDescription,
    nearestAirportsTitle = _ref8.nearestAirportsTitle;
  var attractions = attractionsDescription.replace(/<\/?p>/g, '').split(nearestAirportsTitle).map(function (html) {
    return html.split('<br />').map(function (html) {
      return html.trim();
    }).filter(Boolean);
  });
  return {
    pointsOfInterest: (0, _get2["default"])(attractions, '0', []),
    nearestAirports: (0, _get2["default"])(attractions, '1', [])
  };
}

/**
 * format check in description
 * @param {Object} hotel
 * @return {{checkInBeginTime: string|null, checkInEndTime: string|null, checkOutTime: string|null}}
 */
function formatCheckInDescription(hotel) {
  var fullYear = new Date().getFullYear();
  var checkInBeginTime = (0, _get2["default"])(hotel, 'checkinBeginTime');
  var checkInEndTime = (0, _get2["default"])(hotel, 'checkinEndTime');
  var checkOutTime = (0, _get2["default"])(hotel, 'checkoutTime');
  checkInBeginTime = checkInBeginTime ? (0, _dateFns.format)(new Date("".concat(fullYear, "T").concat(checkInBeginTime)), 'hh:mm a') : null;
  checkInEndTime = checkInEndTime ? (0, _dateFns.format)(new Date("".concat(fullYear, "T").concat(checkInEndTime)), 'hh:mm a') : null;
  checkOutTime = checkOutTime ? (0, _dateFns.format)(new Date("".concat(fullYear, "T").concat(checkOutTime)), 'hh:mm a') : null;
  return {
    checkInBeginTime: checkInBeginTime,
    checkInEndTime: checkInEndTime,
    checkOutTime: checkOutTime
  };
}

/**
 *
 * @param hotelAmenities
 * @returns {Array}
 */
function getSmokingFacility(hotelAmenities) {
  var generalAmenity = (0, _find2["default"])(hotelAmenities, {
    id: _constants.HOTEL_FACILITY_CATEGORIES.GENERAL
  }) || {};
  return (0, _filter2["default"])(generalAmenity.facilities, function (facility) {
    return facility.id === _constants.HOTEL_FACILITIES.SMOKING || facility.id === _constants.HOTEL_FACILITIES.NON_SMOKING;
  });
}

/**
 *
 * @param hotelAmenities
 * @returns {Array}
 */
function getAccessibilityFacility(hotelAmenities) {
  var generalAmenity = (0, _find2["default"])(hotelAmenities, {
    id: _constants.HOTEL_FACILITY_CATEGORIES.ACCESSIBILITY
  }) || {};
  return (0, _filter2["default"])(generalAmenity.facilities, function (facility) {
    return facility.id === _constants.HOTEL_FACILITIES.WHEELCHAIR || facility.id === _constants.HOTEL_FACILITIES.ACCESSIABLE_ROOM;
  });
}

/**
 * check if arabic language is present in the list
 * @param {Array<string>} languages
 * @return {boolean}
 */

function isArabicLanguagePresent(languages) {
  return (0, _includes2["default"])(languages.map(_toLower2["default"]), _constants.SPOKEN_LANGUAGES.AR);
}